const SkillCardSkeleton = () => {
  return (
    <>
      {/* SlidingTabs Skeleton */}
      <div className="flex gap-[12px] flex-wrap overflow-x-auto w-full">
        <div className="flex gap-[12px] animate-pulse">
          {[1, 2, 3].map((_, index) => (
            <div key={index} className="h-10 w-24 bg-gray-300 rounded-lg"></div>
          ))}
        </div>
      </div>

      {/* Skill Cards Skeleton */}
      <div className="mt-4 sm:mt-[24px] flex flex-col gap-4 sm:gap-6">
        {[1, 2, 3].map((_, index) => (
          <div
            key={index}
            className="w-full border border-light-blue rounded-lg sm:rounded-[20px] p-4 sm:p-6 flex flex-col gap-2 sm:gap-[10px] bg-white"
          >
            <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
            <div className="h-4 w-full bg-gray-300 rounded animate-pulse"></div>
          </div>
        ))}
      </div>
    </>
  );
};
export default SkillCardSkeleton;
